import PropTypes from 'prop-types';
export const TabsPropTypes = {
    /** Callback, return tab selected */
    onChange: PropTypes.func,
};
export const TabsDefaultValues = {};
//# sourceMappingURL=tabs.prop-types.js.map